import * as R from 'ramda';

import { getFullUrl } from '../../../utils';

export const createLink = (title, subject, contacts, route, id) => (
  `Follow the link to get the details of the '${title || ''}' task` +
  `${subject ? ` to the '${subject}' request ` : ''}` +
  `${!R.isEmpty(contacts) ?
    `from ${R.map(contact => contact.fullName, contacts).join(', ')}` : ''}` +
  `: ${getFullUrl(`${route}?id=${id}`)}`
);



// WEBPACK FOOTER //
// ./src/components/tasks-list/task-dropdown/helpers.js